import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tree from 'react-treeview'

import Label from './Label'

import './Item.css'

function getIcon(type) {
    switch (type) {
        case 'Layer':
            return 'layers'
        case 'Group':
            return 'folder'
        case 'Path':
            return 'timeline'
        case 'Circle':
            return 'lens'
        case 'Rectangle':
            return 'crop_square'
        case 'Raster':
            return 'photo'
        default:
            return 'insert_drive_file'
    }
}

function getText(type) {
    switch (type) {
        case 'Layer':
            return 'لایه'
        case 'Group':
            return 'گروه'
        case 'Path':
            return 'مسیر'
        case 'Circle':
            return 'lens'
        case 'Rectangle':
            return 'crop_square'
        case 'Raster':
            return 'تصویر'
        default:
            return ''
    }
}

export default class Item extends Component {
    static propTypes = {
        id: PropTypes.any.isRequired,
        type: PropTypes.string.isRequired,
        expanded: PropTypes.object.isRequired,
        activeLayer: PropTypes.number,
        selectedItem: PropTypes.string,
        onArrowClick: PropTypes.func,
        onLabelClick: PropTypes.func,
    }

    handleArrowClick = () => {
        if (this.props.onArrowClick) {
            this.props.onArrowClick(this.props)
        }
    }

    render() {
        const {
            id,
            type,
            data,
            children,
            expanded,
            activeLayer,
            selectedItem,
            onLabelClick,
            onStrokeColorClick,
            onChangeLockClick,
        } = this.props
        const isGroup = type === 'Group' || type === 'Layer'
        const hasChildren = children && children.length > 0
        const labelProps = {
            id,
            type,
            icon: getIcon(type),
            onClick: onLabelClick,
            selected:
                id === selectedItem || (id === activeLayer && !selectedItem),
        }
        const treeProps = {
            collapsed: expanded[id] === false,
            onClick: this.handleArrowClick,
            nodeLabel: (
                <Label {...labelProps}>{`${getText(type)} شماره ${
                    id ?? 0
                }`}</Label>
            ),
        }

        const strokeColors = [
            '#ff0000',
            '#00ff00',
            '#0000ff',
            '#ffff00',
            '#ff00ff',
            '#00ffff',
            '#000000',
        ]

        return (
            <Tree {...treeProps}>
                {hasChildren &&
                    children.map(({ id, type }, num) => {
                        let selectedElement = {},
                            nextStrokeColor = '',
                            islocked = false

                        data.layers[0].children.forEach((element, index) => {
                            if (element.id === this.props.selectedItem) {
                                selectedElement = element

                                islocked = element.locked

                                strokeColors.forEach((color, colorIndex) => {
                                    if (color === selectedElement.strokeColor) {
                                        nextStrokeColor =
                                            strokeColors[colorIndex + 1]
                                    }
                                })

                                if (!nextStrokeColor) {
                                    nextStrokeColor = '#ff0000'
                                }
                            }
                        })

                        return (
                            <Label
                                key={id}
                                id={id}
                                type={type}
                                selected={id === selectedItem}
                                icon={getIcon(type)}
                                onClick={onLabelClick}
                            >
                                {`${getText(type)} شماره ${num + 1}`}

                                {this.props.selectedItem === id && (
                                    <div className={'tree-view_tools'}>
                                        {/* <span
                      className={'tree-view_tools_lock'}
                      onClick={() => onChangeLockClick(this.props)}
                    >
                      <i className={'material-icons'}>
                        {islocked ? 'lock' : 'lock_open'}
                      </i>
                    </span> */}
                                        <span
                                            className={'tree-view_tools_color'}
                                            onClick={() =>
                                                onStrokeColorClick(
                                                    this.props,
                                                    nextStrokeColor
                                                )
                                            }
                                        >
                                            <span
                                                style={{
                                                    backgroundColor:
                                                        selectedElement.strokeColor,
                                                }}
                                            ></span>
                                        </span>
                                    </div>
                                )}
                            </Label>
                        )
                    })}
                {!hasChildren && isGroup && (
                    <Label icon={'insert_drive_file'}>خالی</Label>
                )}
            </Tree>
        )
    }
}
